import React from 'react';

import { IOnboardingContainerProps } from './types';

const OnboardingContainer: React.FC<React.PropsWithChildren<IOnboardingContainerProps>> = ({
  children,
}) => <>{children}</>;

export default OnboardingContainer;
